// Kinvanta brand constants for CherishLink (sister product).
export const KINVANTA_LOGO_URL =
  "https://customer-assets.emergentagent.com/job_kinvio-beta/artifacts/37bsvpug_Kinvanta_logo1%20%281%29.png";

export const KINVANTA_TAGLINE = "Trusted family care coordination, by PaxBond";

export const KINVANTA_RELATIONS = ["Parent", "Grandparent", "Spouse", "Other"];
export const KINVANTA_NEEDS = [
  "Caregiver Help",
  "Emergency Backup",
  "Companionship",
  "Family Coordination",
  "Transportation",
  "Medication Reminders",
  "Unsure",
];
